import {Edit} from "@mui/icons-material";
import {Stack} from "@mui/material";
import React from "react";
import {ElementDto} from "../../../../../common/apis/element/ElementDto";
import SectionActionBar from "../../../../../components/section/SectionActionBar";
import {SectionActionButton} from "../../../../../components/section/SectionActionButton";
import SectionHeader from "../../../../../components/section/SectionHeader";
import {t} from "../../../../../store/localization/TranslMessasge";
import {CommonTranslation} from "../../CommonTranslation";
import {useAttributeDefinitionQuery} from "../../stereotypes/attributes/AttributeDefinitionQuery";
import {useLayoutDefinitionQuery} from "../../stereotypes/layout/LayoutDefinitionQuery";
import StereotypeLayoutRenderer from "../../stereotypes/layout/StereotypeLayoutRenderer";
import {useFindAllReferenceDefinitionsQuery} from "../../stereotypes/reference/ReferenceDefinitionQuery";
import {StereotypesTranslationKey} from "../../stereotypes/StereotypesTranslationKey";
import StereotypeAttrsUpdateDialog from "./StereotypeAttrsUpdateDialog";

interface ElementStereotypeAttrsPanelProps {
    element: ElementDto;
    onUpdate?: () => void;
}

export default function ElementStereotypeAttrsPanel({element, onUpdate}: Readonly<ElementStereotypeAttrsPanelProps>) {
    const [updateDialogOpen, setUpdateDialogOpen] = React.useState(false);

    const stereotypeId = element.stereotype?.id;
    const {data: layoutDefinition} = useLayoutDefinitionQuery(element.stereotype?.id, element.stereotype?.layoutId);
    const {data: attributeDefinitions} = useAttributeDefinitionQuery(stereotypeId);
    const {data: referenceDefinitions} = useFindAllReferenceDefinitionsQuery(stereotypeId);

    if (!attributeDefinitions || !referenceDefinitions || !layoutDefinition) {
        return null;
    }

    function openUpdateDialog() {
        setUpdateDialogOpen(true);
    }

    function closeUpdateDialog() {
        setUpdateDialogOpen(false);
    }

    const canUpdate = element.acl.canUpdate;

    try {
        return (
                <>
                    <Stack spacing={2}>
                        <SectionHeader title={t(StereotypesTranslationKey.STEREOTYPE)}>
                            <SectionActionBar>
                                <SectionActionButton
                                        icon={<Edit fontSize={"inherit"}/>}
                                        tooltip={t(CommonTranslation.EDIT)}
                                        onClick={() => openUpdateDialog()}
                                        visible={canUpdate}/>
                            </SectionActionBar>
                        </SectionHeader>

                        <StereotypeLayoutRenderer
                                element={element}
                                editMode={false}
                                layoutDefinition={layoutDefinition}
                                attributeDefinitions={attributeDefinitions}
                                referenceDefinitions={referenceDefinitions} />
                    </Stack>

                    <StereotypeAttrsUpdateDialog
                            open={updateDialogOpen}
                            onClose={closeUpdateDialog}
                            onUpdate={onUpdate}
                            element={element}
                            layoutDefinition={layoutDefinition}
                            attributeDefinitions={attributeDefinitions}
                            referenceDefinitions={referenceDefinitions} />
                </>
        );
    } catch {
        return null;
    }
}


